import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Formik, Form as FormikForm } from "formik";
import { Form, Button } from "react-bootstrap";
import { FaEnvelope, FaLock, FaUserCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import FormField from "../components/forms/FormField";
import { loginSchema } from "../validation/schemas";
import "./Login.css";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, getErrorMessage } = useAuth();

  return (
    <main className="auth-page">
      <Seo {...PAGE_SEO.login} />
      <section className="auth-card">
        <div className="auth-left">
          <span className="auth-badge">Welcome Back</span>
          <h1>Login to Your Account</h1>
          <p>
            Access your account to manage orders, wishlist items, and quote
            requests.
          </p>
        </div>

        <Formik
          initialValues={{ email: "", password: "", rememberMe: false }}
          validationSchema={loginSchema}
          onSubmit={async (values, { setSubmitting }) => {
            try {
              await login({
                email: values.email,
                password: values.password,
              });
              toast.success("Login successful");
              navigate(location.state?.from || "/", { replace: true });
            } catch (error) {
              toast.error(getErrorMessage(error, "Login failed"));
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, values, handleChange }) => (
            <FormikForm className="auth-form" noValidate>
              <div className="auth-icon">
                <FaUserCircle />
              </div>

              <h2>Login</h2>

              <FormField
                name="email"
                type="email"
                label="Email Address"
                labelIcon={<FaEnvelope />}
                placeholder="Enter your email"
                autoComplete="email"
              />

              <FormField
                name="password"
                type="password"
                label="Password"
                labelIcon={<FaLock />}
                placeholder="Enter password"
                autoComplete="current-password"
              />

              <div className="auth-options">
                <Form.Check
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  label="Remember me"
                  checked={values.rememberMe}
                  onChange={handleChange}
                />
                <Link to="/forgot-password">Forgot Password?</Link>
              </div>

              <Button
                type="submit"
                className="auth-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Logging in..." : "Login"}
              </Button>

              <p className="auth-switch">
                Don’t have an account? <Link to="/register">Register</Link>
              </p>
            </FormikForm>
          )}
        </Formik>
      </section>
    </main>
  );
};

export default Login;
